export enum CrashType {
  COMPONENT = 'COMPONENT',
  ASYNC = 'ASYNC',
  FUNCTION = 'FUNCTION'
}

export interface CrashReport {
  type: CrashType;
  error: Error;
  timestamp: number;
  context?: Record<string, any>;
}

class CrashHandler {
  private static instance: CrashHandler;
  private reports: CrashReport[] = [];

  private constructor() {}

  static getInstance(): CrashHandler {
    if (!CrashHandler.instance) {
      CrashHandler.instance = new CrashHandler();
    }
    return CrashHandler.instance;
  }

  report(type: CrashType, error: Error, context?: Record<string, any>): void {
    const report: CrashReport = {
      type,
      error,
      timestamp: Date.now(),
      context
    };

    this.reports.push(report);
    this.log(report);
  }

  private log(report: CrashReport): void {
    console.error(`[${report.type}] Crash Report:`, {
      message: report.error.message,
      stack: report.error.stack,
      timestamp: new Date(report.timestamp).toISOString(),
      context: report.context
    });
  }

  getReports(): CrashReport[] {
    return [...this.reports];
  }

  clearReports(): void {
    this.reports = [];
  }
}

export const crashHandler = CrashHandler.getInstance();
